function analyticsEventsInit() {
  window.gaTrackEvent = function (category, action, label, value) {
    if (typeof ga === 'function') {
      const tracker = ga.getAll()[0];

      if (tracker) {
        tracker.send('event', category, action, label, value);
      }
    }
  };
}

export default analyticsEventsInit();
